import { Fragment, useEffect } from "react";

import "@/common/styles/page.scss";
import { TrendingCreators } from "@/components/widgets/TrendingCreators";
import { TrendingNiches } from "@/components/widgets/TrendingNiches";
import { TrendingTags } from "@/components/widgets/TrendingTags";
import { WithSideAds } from "@/components/ads";
import { className } from "@/common/utils/strings";
import { useDeviceType } from "@/common/hooks";
import { ContentPageSkyscraperEnum } from "components/ads/config/units/contentPageSkyscraper";
import { FooterAds } from "components/ads/FooterAds";

import { NewCreators } from "../NewCreators";
import { TopGifs } from "../TopGifs";
import { TrendingGifs } from "../TrendingGifs";
import { TrendingImages } from "../TrendingImages";

import "./ExplorePage.scss";
import { useAnalyticsStore } from "@/common/store/analyticsStore";
import { EventSource } from "@/common/buses";

export const ExplorePage = () => {
  const deviceType = useDeviceType();
  const setEventSource = useAnalyticsStore((state) => state.setEventSource);

  useEffect(() => {
    setEventSource({ name: EventSource.Explore });
  }, []);

  return (
    <Fragment>
      <WithSideAds
        leftAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperL1,
          ContentPageSkyscraperEnum.ContentPageSkyscraperL2,
          ContentPageSkyscraperEnum.ContentPageSkyscraperL3,
        ]}
        rightAds={[
          ContentPageSkyscraperEnum.ContentPageSkyscraperR1,
          ContentPageSkyscraperEnum.ContentPageSkyscraperR2,
          ContentPageSkyscraperEnum.ContentPageSkyscraperR3,
        ]}
      >
        <div className={className({
          "explorePage": true,
          "narrow page": true,
          [deviceType]: true,
        })}>
          <TopGifs />
          <TrendingNiches listSize={8} />
          <NewCreators />
          <TrendingImages />
          <TrendingCreators list={true} />
          <TrendingGifs />
          <TrendingTags />
        </div>
      </WithSideAds>

      <FooterAds/>
    </Fragment>
  );
};
